<template>
  <v-app-bar
    flat
    elevation="1"
    :color="color.mainColor()"
    height="50"
  >
    <v-container fluid>
      <v-row
        dense
        align="center"
        justify="start"
      >
        <v-col>
          <v-app-bar-title
            class="font-weight-bold text-white font-size-1125-rem"
          >
            産婦人科・小児科オンライン利用状況管理画面
          </v-app-bar-title>
        </v-col>
        <template v-if="isLogin">
          <v-col
            align-self="stretch"
            class="mt-1"
          >
            <vue-select
              v-model="corporationId"
              class="corporation-select"
              label="name"
              append-to-body
              :calculate-position="customizePosition"
              :clearable="false"
              :options="corporations"
              :reduce="corporation => corporation.id"
              @option:selected="saveSelectedCorporation"
            >
              <template #no-options>
                <span class="text-color-light-gray">該当する法人はありません</span>
              </template>
            </vue-select>
          </v-col>
          <v-col
            align-self="center"
            cols="1"
            class="pl-2"
          >
            <v-btn
              prepend-icon="custom:logout"
              variant="text"
              color="white"
              to="/login"
              class="btn-logout"
              @click="$emit('logout')"
            >
              ログアウト
            </v-btn>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, computed, h} from "vue"
import router from "../../router/index"
import { useStore } from "../../stores/index"
import vueSelect from "vue-select"
import "vue-select/dist/vue-select.css"
import { roles } from "../../service/roles"
import { themeColor } from "../../service/theme_color"

vueSelect.props.components.default = () => ({
  OpenIndicator: {
    render: () => h('span', '▼'),
  },
});
export default defineComponent({
  name: "AppBarPart",
  components: {
    vueSelect
  },
  props: {
    isLogin: {
      type: Boolean,
      required: true
    },
  },
  emits: ["logout"],
  setup(props) {
    // vuex
    const store = useStore()

    const corporations  = computed(() => store.getters.corporationsInCharge)
    const selectedCorporationId  = computed(() => store.getters.selectedCorporationId)
    const corporationId  = ref(selectedCorporationId.value)
    const isLogin = computed(() => props.isLogin)
    const role = roles()
    const color = themeColor()

    onMounted(async () => {
      if(isLogin.value == false) return;

      // corporationIdが設定済みだがcorporationデータが未取得の場合、fetchCorporationsInChargeを待たずに即座に再取得する
      // （ページリロード時のタイミング問題: sessionStorageからIDは復元されるがcorporationオブジェクトは未取得）
      if ( corporationId.value !== null && !store.getters.corporation ) {
        await store.dispatch("commitSelectedCorporationId", corporationId.value)
      }

      await store.dispatch("fetchCorporationsInCharge").then(() => {
        if( corporationId.value === null ){
          store.dispatch("commitSelectedCorporationId", store.getters.corporationsInCharge[0].id).then(() => {
            // 明示的に設定し直す必要がありそう
            corporationId.value = store.getters.selectedCorporationId
          })
        }
      })
    })

    const saveSelectedCorporation = async () => {
      await store.dispatch("commitSelectedCorporationId", corporationId.value).then(() => {
        // 法人を切り替えたらホームへ遷移する
        router.push("/")
      })
    }

    const customizePosition = (dropdownList: HTMLUListElement, _component: Vue, {width, left}: { width: string; left: string }) => {
      dropdownList.classList.add("corporation-chooser")
      dropdownList.style.top = "51px"
      dropdownList.style.left = left
      dropdownList.style.width = width
    }

    return {
      corporations,
      corporationId,
      role,
      color,
      isLogin,
      saveSelectedCorporation,
      customizePosition
    }
  }
})
</script>
<style lang="scss">
.corporation-select.v-select {
  background-color: #fff;
  border-radius: 4px;
  .vs__open-indicator {
    font-size: 0.7rem;
  }
  .vs__selected {
    color: #222;
    font-weight: bold;
  }
}
.corporation-chooser.vs__dropdown-menu {
  z-index: 1010;
  position: fixed;
  color: #222;
}
.btn-logout {
  .v-btn__prepend {
    margin-right: 0;
  }
}
</style>
